import { Box } from 'components/Blocks';
import { ReactNode } from 'react';

interface IconBoxProps {
  children?: ReactNode;
}

export function IconBox({ children }: IconBoxProps) {
  return (
    <Box border="rounded" className="border border-border p-2 text-primary">
      {children}
    </Box>
  );
}
